export default {
  MuiRadio: {
    root: {
      display: 'none',
    },
  },
};
